<template>
    <div>
        <div class="row mt20">
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-address-book"></i>
                            Identification du vendeur
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <label>
                                La carte grise est-elle au nom d'une entreprise (C.1) ?
                                <span
                                v-tooltip.top-center="'Si oui, le nom de l’entreprise est présent au niveau de la référence (C.1) de la carte grise ?'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
                            </label>
                            <button
                                v-for="option in yesNoOptions"
                                :key="option.text"
                                @click="updateIsProfessionalValue(option)"
                                type="button"
                                class="btn btn-w-m mt20 mr6"
                                :class="[option.value === sellerInfos.isProfessional ? 'btn-primary' : 'btn-secondary']"
                            >
                                {{ option.text }}
                            </button>
                        </div>
                    </div>
                    <div class="row mt20" v-show="sellerInfos.isProfessional === 'yes'">
                        <div class="col-md-12">
                            <label>Le vendeur est-il administrateur de la société ?</label>
                            <button
                                v-for="option in yesNoOptions"
                                :key="option.text"
                                @click="updateIsSellerCompanyAdminValue(option)"
                                type="button"
                                class="btn btn-w-m mt20 mr6"
                                :class="[option.value === sellerInfos.isSellerCompanyAdmin ? (sellerInfos.isSellerCompanyAdmin === 'yes' ? 'btn-primary' : 'btn-danger') : 'btn-secondary']"
                            >
                                {{ option.text }}
                            </button>
                            <p v-if="sellerInfos.isSellerCompanyAdmin && sellerInfos.isSellerCompanyAdmin !== 'yes'"
                                class="text-error mt20"
                            >
                                Désolé le vendeur doit -être l'administrateur de la société.
                            </p>
                        </div>
                    </div>
                    <div class="row mt20" v-show="sellerInfos.isProfessional === 'no'">
                        <div class="col-md-12">
                            <label>
                                Le vendeur est-il le titulaire principal du véhicule (C.1) ?
                                <span
                                v-tooltip.top-center="'Si oui, le nom du vendeur est présent au niveau de la référence (C.1) de la carte grise ?'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
                            </label>
                            <button
                                v-for="option in yesNoOptions"
                                :key="option.text"
                                @click="updateIsSellerOwnerValue(option)"
                                type="button"
                                class="btn btn-w-m mt20 mr6"
                                :class="[option.value === sellerInfos.isSellerOwner ? 'btn-primary' : 'btn-secondary']"
                            >
                                {{ option.text }}
                            </button>
                        </div>
                    </div>
                    <div class="row mt20" v-show="sellerInfos.isProfessional === 'no'">
                        <div class="col-md-12">
                            <label>
                                Y'a t-il un cotitulaire ?
                                <span
                                v-tooltip.top-center="'Y’a-t-il un nom présent au niveau de la référence (C.4.1) de la carte grise ?'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
                            </label>
                            <button
                                v-for="option in yesNoOptions"
                                :key="option.text"
                                @click="updateHasCoOwnerValue(option)"
                                type="button"
                                class="btn btn-w-m mt20 mr6"
                                :class="[option.value === sellerInfos.hasCoOwner ? 'btn-primary' : 'btn-secondary']"
                            >
                                {{ option.text }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="sellerInfos.isSellerOwner === 'yes' && sellerInfos.hasCoOwner && sellerInfos.isProfessional === 'no'">
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-user"></i>
                            Informations du vendeur
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 response">
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_3"
                                        color="success"
                                        value="M"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mr.
                            </p-radio>
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_3"
                                        color="success"
                                        value="MME"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mme.
                            </p-radio>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-6">
                            <label>Prénom</label>
                            <input name="seller.firstName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.firstName">
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nom</label>
                            <input name="seller.lastName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.lastName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerInfos.seller.email ? errors.first('seller.email'): false}"
                        >
                            <label>Email</label>
                            <input name="seller.email"
                                    v-validate="'required|email'"
                                    type="email"
                                    class="form-control"
                                    v-model="sellerInfos.seller.email">
                        </div>
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerPhoneError}"
                        >
                            <label>Téléphone</label>
                            <input name="seller.phone"
                                    type="text"
                                    class="form-control"
                                   maxlength=10
                                   @keyup="onKeyupPhoneNumber"
                                    v-model="sellerInfos.seller.phone">
                        </div>
                        <p v-if="sellerInfos.seller.email && errors.first('seller.email')"
                            class="text-error"
                        >
                            Désolé, l'email ne respecte pas nos conditions
                        </p>
                        <p v-if="sellerInfos.seller.phone && sellerPhoneError"
                            class="text-error"
                        >
                            Désolé, le téléphone ne respecte pas nos conditions (10 chiffres)
                        </p>
                    </div>
                    <!-- <div class="row">
                        <div class="form-group col-md-6"
                                id="seller_date_of_birth_3"
                        >
                            <label>Date de naissance</label>
                            <div class="input-group date">
                                <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                                <input type="text"
                                        id="sellerDateOfBirth3"
                                        class="form-control"
                                >
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Adresse</label>
                            <gmap-autocomplete ref="gmapAddressSeller3"
                                                :componentRestrictions="{'country': ['fr']}"
                                                class="form-control"
                                                @place_changed="(p) => onPlaceChanged(p, 'seller')"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-show="sellerInfos.isSellerOwner === 'no' && sellerInfos.hasCoOwner && sellerInfos.isProfessional === 'no'">
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-user"></i>
                            Informations du vendeur
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 response">
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_1"
                                        color="success"
                                        value="M"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mr.
                            </p-radio>
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_1"
                                        color="success"
                                        value="MME"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mme.
                            </p-radio>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-6">
                            <label>Prénom</label>
                            <input name="seller.firstName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.firstName">
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nom</label>
                            <input name="seller.lastName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.lastName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerInfos.seller.email ? errors.first('seller.email') : false}"
                        >
                            <label>Email</label>
                            <input name="seller.email"
                                    v-validate="'required|email'"
                                    type="email"
                                    class="form-control"
                                    v-model="sellerInfos.seller.email">
                        </div>
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerPhoneError}"
                        >
                            <label>Téléphone</label>
                            <input name="seller.phone"
                                    type="text"
                                    class="form-control"
                                   maxlength=10
                                   @keyup="onKeyupPhoneNumber"
                                    v-model="sellerInfos.seller.phone">
                        </div>
                        <p v-if="sellerInfos.seller.email && errors.first('seller.email')"
                            class="text-error"
                        >
                            Désolé, l'email ne respecte pas nos conditions
                        </p>
                        <p v-if="sellerInfos.seller.phone && sellerPhoneError"
                            class="text-error"
                        >
                            Désolé, le téléphone ne respecte pas nos conditions (10 chiffres)
                        </p>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Adresse</label>
                            <gmap-autocomplete ref="gmapAddressSeller1"
                                                :componentRestrictions="{'country': ['fr']}"
                                                class="form-control"
                                                @place_changed="(p) => onPlaceChanged(p, 'seller')"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-user"></i>
                            Infos titulaire
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 response">
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="owner_civility_2"
                                        color="success"
                                        value="M"
                                        v-model="sellerInfos.owner.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mr.
                            </p-radio>
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="owner_civility_2"
                                        color="success"
                                        value="MME"
                                        v-model="sellerInfos.owner.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mme.
                            </p-radio>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-6">
                            <label>Prénom</label>
                            <input name="owner.firstName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.owner.firstName">
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nom</label>
                            <input name="owner.lastName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.owner.lastName">
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="form-group col-md-6"
                                id="owner_date_of_birth_2"
                        >
                            <label>Date de naissance</label>
                            <div class="input-group date">
                                <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                                <input type="text"
                                        id="ownerDateOfBirth2"
                                        class="form-control"
                                >
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="row mt20" v-show="sellerInfos.isProfessional === 'yes' && sellerInfos.isSellerCompanyAdmin === 'yes'">
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-user"></i>
                            Informations du vendeur
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 response">
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_2"
                                        color="success"
                                        value="M"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mr.
                            </p-radio>
                            <p-radio class="p-icon p-round p-bigger p-pulse"
                                        name="seller_civility_2"
                                        color="success"
                                        value="MME"
                                        v-model="sellerInfos.seller.civility">
                                <i slot="extra" class="icon fa fa-check"></i>
                                Mme.
                            </p-radio>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-6">
                            <label>Prénom</label>
                            <input name="seller.firstName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.firstName">
                        </div>
                        <div class="form-group col-md-6">
                            <label>Nom</label>
                            <input name="seller.lastName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.seller.lastName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerInfos.seller.email ? errors.first('seller.email') : false}"
                        >
                            <label>Email</label>
                            <input name="seller.email"
                                    type="email"
                                    class="form-control"
                                    v-model="sellerInfos.seller.email">
                        </div>
                        <div class="form-group col-md-6"
                                :class="{'has-error': sellerPhoneError}"
                        >
                            <label>Téléphone</label>
                            <input name="seller.phone"
                                    v-validate="'required|email'"
                                    type="text"
                                    class="form-control"
                                   maxlength=10
                                   @keyup="onKeyupPhoneNumber"
                                    v-model="sellerInfos.seller.phone">
                        </div>
                        <p v-if="sellerInfos.seller.email && errors.first('seller.email')"
                            class="text-error"
                        >
                            Désolé, l'email ne respecte pas nos conditions
                        </p>
                        <p v-if="sellerInfos.seller.phone && sellerPhoneError"
                            class="text-error"
                        >
                            Désolé, le téléphone ne respecte pas nos conditions (10 chiffres)
                        </p>
                    </div>
                    <!-- <div class="row">
                        <div class="form-group col-md-6"
                                id="seller_date_of_birth_1"
                        >
                            <label>Date de naissance</label>
                            <div class="input-group date">
                                <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                                <input type="text"
                                        id="sellerDateOfBirth1"
                                        class="form-control"
                                >
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Adresse</label>
                            <gmap-autocomplete ref="gmapAddressSeller2"
                                                :componentRestrictions="{'country': ['fr']}"
                                                class="form-control"
                                                @place_changed="(p) => onPlaceChanged(p, 'seller')"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-building "></i>
                           Infos entreprise
                            <hr>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-12">
                            <label>Raison sociale</label>
                            <input name="owner.companyName"
                                    type="text"
                                    class="form-control"
                                    v-model="sellerInfos.owner.companyName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Numéro de SIRET (14 caractères)</label>
                            <input name="owner.siretNumber"
                                    type="text"
                                    class="form-control"
                                    @keyup="sellerInfos.owner.siretNumber = sellerInfos.owner.siretNumber.replace(/\D/, '')"
                                    v-validate="'regex:^$|^\\d{14}$'"
                                    v-model="sellerInfos.owner.siretNumber">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" 
            v-show="
                (sellerInfos.isSellerOwner && sellerInfos.hasCoOwner && sellerInfos.isProfessional === 'no') ||
                (sellerInfos.isProfessional === 'yes' && sellerInfos.isSellerCompanyAdmin === 'yes')
            "
        >
            <div class="col-md-6 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-newspaper-o"></i>
                            Accord marketing
                            <hr>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeSellerMarketingRadio" class="col-md-2">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="sellerInfos.seller.marketingRadio"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-10">
                            <label @click="onChangeSellerMarketingRadio" class="cursorPointer">Le client accepte de recevoir des communications et des offres personalisées de la part de Carizy.</label>
                        </div>
                    </div>
                    <div class="row mt20" v-if="sellerInfos.seller.marketingRadio">
                        <div class="col-md-2"></div>
                        <div class="col-md-10">
                            <div>
                                <label>Par sms :</label>
                                <button
                                    v-for="option in trueFalseOptions"
                                    :key="option.text"
                                    @click="updateMarketingSmsValue(option)"
                                    type="button"
                                    class="btn btn-w-m mt20 mr6"
                                    :class="[option.value === sellerInfos.seller.marketingSmsCheckbox ? 'btn-primary' : 'btn-secondary']"
                                >
                                    {{ option.text }}
                                </button>
                            </div>
                            <div class="mt20">
                                <label>Par email:</label>
                                <button
                                    v-for="option in trueFalseOptions"
                                    :key="option.text"
                                    @click="updateMarketingEmailValue(option)"
                                    type="button"
                                    class="btn btn-w-m mt20 mr6"
                                    :class="[option.value === sellerInfos.seller.marketingEmailCheckbox ? 'btn-primary' : 'btn-secondary']"
                                >
                                    {{ option.text }}
                                </button>
                            </div>
                        </div> 
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeSellerMarketingPartnerRadio" class="col-md-2">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="sellerInfos.seller.marketingPartnerRadio"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-10">
                            <label @click="onChangeSellerMarketingPartnerRadio" class="cursorPointer">Le client accepte que ses coordonnées téléphoniques soient transmises aux partenaires de CARIZY.com</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pa17">
            <button
                    @click="goToPreviousStep"
                    type="button"
                    class="pull-left btn btn-w-m"
                    :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
            >
                Précédent
            </button>
            <button
                    @click="goToNextStep"
                    type="button"
                    :disabled="disableGoToNextStep"
                    class="btn btn-w-m pull-right"
                    :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
            >
                Suivant
            </button>
        </div>
    </div>
</template>


<script>
    import gql from 'graphql-tag'
    import { formatAddress, addressToString } from '../../../helpers/utils'

    export default {
        name: "Seller",

        props: {
            activeStep: {
                type: Number,
                required: true
            },
            entity: {
                type: String,
                required: true
            },
            vehicle: {
                type: Object
            },
            quotation: {
                type: Object,
            },
            sellerInfosProp: {
                type: Object
            },
            vehicleInfosProp: {
                type: Object
            },
        },

        data: () => ({
            autoSave: null,
            yesNoOptions: [
                { text: "Oui", value: "yes" },
                { text: "Non", value: "no" },
            ],
            trueFalseOptions: [
                { text: "Oui", value: true },
                { text: "Non", value: false },
            ],
            sellerInfos: {
                isSellerOwner: "",
                isSellerCoOwner: "",
                hasCoOwner: "",
                isProfessional: "",
                isSellerCompanyAdmin: "",
                owner: {
                    civility: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    //usedName: "",
                    // dateOfBirth: "",
                    address: {
                        address: "",
                        city: "",
                        zipCode: ""
                    },
                    companyName: "",
                    siretNumber: ""
                },
                seller: {
                    civility: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    usedName: "",
                    // birthDate: "",
                    //birthPlace: "",
                    // dateOfBirth: "",
                    address: {
                        address: "",
                        city: "",
                        zipCode: ""
                    },
                    marketingRadio: false,
                    marketingPartnerRadio: false,
                    marketingSmsCheckbox: "",
                    marketingEmailCheckbox: "",
                    coordinate: {
                      latitude: null,
                      longitude: null,
                    }
                }
            }
        }),

        computed: {
            ownerPhoneError () {
                if(this.sellerInfos.owner.phone && this.sellerInfos.owner.phone.length !== 10) {
                    return true
                } else {
                    return false
                }
            },
            sellerPhoneError () {
                if(this.sellerInfos.seller.phone && this.sellerInfos.seller.phone.length !== 10) {
                    return true
                } else {
                    return false
                }
            },
            sellerEmailIsValid(){
                if (
                    this.sellerInfos.seller.email &&
                    (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.sellerInfos.seller.email))
                )
                {
                    return true
                }
                return false
            },
            ownerEmailIsValid(){
                if (
                    this.sellerInfos.owner.email &&
                    (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.sellerInfos.owner.email))
                )
                {
                    return true
                }
                return false
            },
            disableGoToNextStep () {
                if (
                    this.sellerInfos.isProfessional  === ''
                ) {
                    return true
                } else if (
                    (this.sellerInfos.isProfessional  === 'no' && this.sellerInfos.isSellerOwner === '') ||
                    (this.sellerInfos.isProfessional  === 'no' && this.sellerInfos.hasCoOwner === '')
                ) {
                    return true
                } else if (
                    (
                        this.sellerInfos.isSellerOwner === 'yes' &&
                        this.sellerInfos.hasCoOwner &&
                        this.sellerInfos.isProfessional === 'no'
                    ) &&
                    (
                        !this.sellerInfos.seller.civility ||
                        !this.sellerInfos.seller.firstName ||
                        !this.sellerInfos.seller.lastName ||
                        !this.sellerInfos.seller.email ||
                        !this.sellerInfos.seller.phone ||
                        //!this.sellerInfos.seller.usedName ||
                        //!this.sellerInfos.seller.birthPlace ||
                        // !this.sellerInfos.seller.dateOfBirth ||
                        !this.sellerInfos.seller.address.address ||
                        this.sellerPhoneError ||
                        this.errors.first('seller.email') ||

                        (
                            this.sellerInfos.seller.marketingRadio &&
                            this.sellerInfos.seller.marketingSmsCheckbox === "" &&
                            this.sellerInfos.seller.marketingEmailCheckbox === ""
                        )
                    )
                ){
                    return true
                } else if (
                    this.sellerInfos.isSellerOwner === 'no' &&
                    this.sellerInfos.hasCoOwner &&
                    this.sellerInfos.isProfessional === 'no' &&
                    (
                        !this.sellerInfos.seller.civility ||
                        !this.sellerInfos.seller.firstName ||
                        !this.sellerInfos.seller.lastName ||
                        !this.sellerInfos.seller.email ||
                        !this.sellerInfos.seller.phone ||
                        !this.sellerInfos.seller.address.address ||
                        this.sellerPhoneError ||
                        this.errors.first('seller.email')||

                        (
                            this.sellerInfos.seller.marketingRadio &&
                            this.sellerInfos.seller.marketingSmsCheckbox === "" &&
                            this.sellerInfos.seller.marketingEmailCheckbox === ""
                        ) ||

                        !this.sellerInfos.owner.civility ||
                        !this.sellerInfos.owner.firstName ||
                        !this.sellerInfos.owner.lastName
                        // !this.sellerInfos.owner.dateOfBirth
                    )
                ) {
                    return true
                } else if (
                    this.sellerInfos.isProfessional === 'yes' &&
                    this.sellerInfos.hasCoOwner &&
                    this.sellerInfos.isSellerOwner &&
                    (
                        this.sellerInfos.isSellerCompanyAdmin !== "yes" ||
                        !this.sellerInfos.seller.civility ||
                        !this.sellerInfos.seller.firstName ||
                        !this.sellerInfos.seller.lastName ||
                        !this.sellerInfos.seller.email ||
                        !this.sellerInfos.seller.phone ||
                        // !this.sellerInfos.seller.dateOfBirth ||
                        !this.sellerInfos.seller.address.address ||

                        this.sellerPhoneError ||
                        this.errors.first('seller.email') ||

                        (
                            this.sellerInfos.seller.marketingRadio &&
                            this.sellerInfos.seller.marketingSmsCheckbox === "" &&
                            this.sellerInfos.seller.marketingEmailCheckbox === ""
                        )
                    )
                ) {
                    return true
                } else {
                    return false
                }
            }
        },

        beforeDestroy () {
            clearInterval(this.autoSave)
        },

        created () {
            this.autoSaveData()
        },

        methods: {
            onKeyupPhoneNumber(event) {
              if (event.key === "Backspace") {
                return
              }

              let formattedPhoneNumber = this.sellerInfos.seller.phone.toUpperCase()
              this.sellerInfos.seller.phone = formattedPhoneNumber.replace(/\s/, '').replace(/[a-zA-Z]/, '')
            },
          scrollToTop() {
                window.scrollTo(0,0);
            },
            autoSaveData () {
                this.autoSave = setInterval(() => {
                    this.$emit('pass-seller-infos-data', this.sellerInfos)
                }, 1000)
            },
            goToPreviousStep () {
                clearInterval(this.autoSave)
                this.$emit('go-to-previous-step', 3)
            },
            goToNextStep () {
                clearInterval(this.autoSave)
                this.$emit('pass-seller-infos-data', this.sellerInfos)
                this.$emit('go-to-next-step', 5)
            },
            resetOwnerData () {
                this.sellerInfos.owner = {
                    civility: "",
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    //usedName: "",
                    // dateOfBirth: "",
                    address: {
                        address: "",
                        city: "",
                        zipCode: ""
                    },
                    companyName: "",
                    siretNumber: ""
                }
            },
            resetSellerData () {
                // Seller Address
                this.$refs.gmapAddressSeller3.$el.value = addressToString(this.sellerInfos.seller.address)
                this.$refs.gmapAddressSeller1.$el.value = addressToString(this.sellerInfos.seller.address)
                this.$refs.gmapAddressSeller2.$el.value = addressToString(this.sellerInfos.seller.address)
            },
            onChangeIsSellerOwnerRadio () {
                this.resetOwnerData()
                this.resetSellerData()
            },
            onChangeHasCoOwnerRadio () {
                this.resetOwnerData()
                this.resetSellerData()
                this.sellerInfos.isSellerCoOwner = ""
            },
            onChangeIsProfessionalRadio () {
                this.resetOwnerData()
                this.resetSellerData()
            },
            onPlaceChanged (place, type) {
                this.sellerInfos[type].address = formatAddress(place)
                this.sellerInfos[type].coordinate.latitude = place.geometry.location.lat();
                this.sellerInfos[type].coordinate.longitude = place.geometry.location.lng();
            },
            onChangeSellerMarketingRadio () {
                this.sellerInfos.seller.marketingRadio = !this.sellerInfos.seller.marketingRadio
                if(this.sellerInfos.seller.marketingRadio){
                    this.sellerInfos.seller.marketingSmsCheckbox = true
                    this.sellerInfos.seller.marketingEmailCheckbox = true
                } else {
                    this.sellerInfos.seller.marketingSmsCheckbox = ""
                    this.sellerInfos.seller.marketingEmailCheckbox = ""
                }   
            },
            onChangeSellerMarketingPartnerRadio () {
                this.sellerInfos.seller.marketingPartnerRadio = !this.sellerInfos.seller.marketingPartnerRadio
            },
            updateIsSellerOwnerValue (option) {
                this.sellerInfos.isSellerOwner = option.value
                this.onChangeIsSellerOwnerRadio()
            },
            updateHasCoOwnerValue (option) {
                this.sellerInfos.hasCoOwner = option.value
                this.onChangeHasCoOwnerRadio()
            },
            updateIsProfessionalValue (option) {
                this.sellerInfos.isProfessional = option.value
                this.sellerInfos.isSellerCompanyAdmin = ""
                this.sellerInfos.isSellerOwner = ""
                this.sellerInfos.hasCoOwner = ""
                this.onChangeIsProfessionalRadio()
            },
            updateIsSellerCompanyAdminValue (option) {
                this.sellerInfos.isSellerCompanyAdmin = option.value
                this.onChangeIsProfessionalRadio()
            },
            updateIsSellerCoOwnerValue (option) {
                this.sellerInfos.isSellerCoOwner = option.value
            },
            updateMarketingSmsValue (option) {
                this.sellerInfos.seller.marketingSmsCheckbox = option.value
            },
            updateMarketingEmailValue (option) {
                this.sellerInfos.seller.marketingEmailCheckbox = option.value
            }
        },

        mounted () {
            $(document).trigger('vue-loaded')
            this.scrollToTop()
            if(this.sellerInfosProp){
                this.sellerInfos = this.sellerInfosProp

                if(this.vehicleInfosProp.address.address){
                    this.sellerInfos.seller.address.address = this.vehicleInfosProp.address.address
                    this.sellerInfos.seller.address.city = this.vehicleInfosProp.address.city
                    this.sellerInfos.seller.address.zipCode = this.vehicleInfosProp.address.zipCode
                }
                // Seller Address
                this.$refs.gmapAddressSeller3.$el.value = addressToString(this.sellerInfos.seller.address)
                // Seller Address
                this.$refs.gmapAddressSeller1.$el.value = addressToString(this.sellerInfos.seller.address)
                this.$refs.gmapAddressSeller2.$el.value = addressToString(this.sellerInfos.seller.address)
            } else {
                if(this.quotation && this.quotation.customer){
                    this.sellerInfos.seller.civility = this.quotation.customer.civility
                    this.sellerInfos.seller.firstName = this.quotation.customer.firstname
                    this.sellerInfos.seller.lastName = this.quotation.customer.lastname
                    //this.sellerInfos.seller.usedName = this.quotation.customer.usedName
                    //this.sellerInfos.seller.birthPlace = this.quotation.customer.birthPlace
                    //this.sellerInfos.seller.birthDate = this.quotation.customer.birthDate
                    this.sellerInfos.seller.email = this.quotation.customer.email
                    this.sellerInfos.seller.phone = this.quotation.customer.phone
                    this.sellerInfos.seller.address.address = this.quotation.customer.address.address
                    this.sellerInfos.seller.address.city = this.quotation.customer.address.city
                    this.sellerInfos.seller.address.zipCode = this.quotation.customer.address.zipCode
                }
                if(this.vehicleInfosProp.address.address && this.vehicleInfosProp.addressRadio === 1){
                        this.sellerInfos.seller.address.address = this.vehicleInfosProp.address.address
                        this.sellerInfos.seller.address.city = this.vehicleInfosProp.address.city
                        this.sellerInfos.seller.address.zipCode = this.vehicleInfosProp.address.zipCode
                }

                // Seller Address
                this.$refs.gmapAddressSeller1.$el.value = addressToString(this.sellerInfos.seller.address)
                this.$refs.gmapAddressSeller2.$el.value = addressToString(this.sellerInfos.seller.address)
                this.$refs.gmapAddressSeller3.$el.value = addressToString(this.sellerInfos.seller.address)
            }
        },
    }
</script>

<style scoped>

</style>
